export const attachClassToStudent = (student, schoolClass) => ({
  ...student,
  class: {
    id: schoolClass.id,
    name: schoolClass.name,
    programme: schoolClass.programme,
  },
});
